// extracted by mini-css-extract-plugin
module.exports = {"container":"UqHwX","title":"_2cvpc","postsList":"_2OW3c","postListItem":"QOArR"};